import React from "react";
import "../styles/Pages.css";
import "../styles/Centers.css";

export const ALL_CENTERS = [
  {
    country: "India",
    locations: [
      {
        city: "Hariprabodham Dham",
        map: {
          lat: "22.396887",
          lng: "73.248287",
        },
        links: [
          {
            label: "HariPrabodham Dham",
            url: "https://ihariprabodham.org/hariprabodham-dham",
          },
          {
            label: "iHariPrabodham - YouTube",
            url: "https://www.youtube.com/@ihariprabodham",
          },
        ],
      },

      {
        city: "AVD, Bakrol",
        map: {
          lat: "22.557726",
          lng: "72.918393",
        },
        links: [
          {
            label: "HariPrabodham",
            url: "https://ihariprabodham.org/",
          },
          {
            label: "iHariPrabodham - YouTube",
            url: "https://www.youtube.com/@ihariprabodham",
          },
        ],
      },
      {
        city: "AVN, Amadavad",
        map: {
          lat: "23.078102",
          lng: "72.558134",
        },
        links: [
          {
            label: "HariPrabodham Baheno",
            url: "https://ihariprabodham.org/pravachan/baheno-pravachan",
          },
        ],
      },
      {
        city: "AVM, Bharathana",
        map: {
          lat: "21.266602",
          lng: "73.008969",
        },
        links: [
          {
            label: "Atmiya Vidya Mandir",
            url: "https://avm.edu.in/",
          },
        ],
      },
      {
        city: "Mumbai",
        map: {
          lat: "19.1627349",
          lng: "72.8306733",
        },
        links: [
          {
            label: "HariPrabodham Mumbai - YouTube",
            url: "https://www.youtube.com/@HariPrabodhamMumbai",
          },
        ],
      },

      {
        city: "Harisumiran Prarthana Mandir - Bhuj",
        map: {
          lat: "23.251215",
          lng: "69.610947",
        },
        links: [],
      },
      {
        city: "Hariprabodham Sanksar Dham - Borbhatha Bet",
        map: {
          lat: "21.680362",
          lng: "73.004744",
        },
        links: [],
      },
    ],
  },
  {
    country: "USA",
    locations: [
      {
        city: "New Jersey",
        map: {
          query: "VJG7+XV Lake Hiawatha, Parsippany-Troy Hills, NJ, USA",
        },
        links: [
          {
            label: "Harisumiran NJ | Yogi Divine Society",
            url: "https://www.harisumiran.org/",
          },
          {
            label: "Harisumiran - YouTube",
            url: "https://www.youtube.com/@harisumiran-nj",
          },
        ],
      },
      {
        city: "Houston",
        map: {
          query: "5850 Louetta Rd, Spring, TX 77379, USA",
        },
        links: [
          {
            label: "Houston TX Home Page | Harisumiran NJ",
            url: "https://www.harisumiran.org/tx/",
          },
        ],
      },
      {
        city: "Chicago",
        map: {
          query: "1670 Checker Rd, Long Grove, IL 60047, USA",
        },
        links: [
          {
            label: "Chicago IL Home Page | Harisumiran NJ",
            url: "https://www.harisumiran.org/il/",
          },
        ],
      },
    ],
  },
  {
    country: "Canada",
    locations: [
      {
        city: "Mississauga",
        map: {
          query: "6875 Professional Ct, Mississauga, ON L4V 1Y3",
        },
        links: [
          {
            label: "Home - YDS Canada",
            url: "https://home.ydscanada.org/",
          },
          {
            label: "YDS Canada - YouTube",
            url: "https://www.youtube.com/ydscanada",
          },
        ],
      },
      {
        city: "Winnipeg",
        links: [],
      },
    ],
  },
  {
    country: "UK",
    locations: [
      {
        city: "Harrow",
        map: {
          query: "63 Woodcock Hill, Harrow HA3 0JH, United Kingdom",
        },
        links: [
          {
            label: "HariPrabodham UK - YouTube",
            url: "https://www.youtube.com/@HariPrabodhamUK",
          },
        ],
      },
      {
        city: "Leicester",
        links: [],
      },
    ],
  },
  {
    country: "Germany",
    locations: [
      {
        city: "Kleinmachnow",
        map: {
          query: "Im Tal 16, 14532 Kleinmachnow",
        },
        links: [
          {
            label: "Home - Yogi Divine Society",
            url: "https://yds-germany.de/",
          },
          {
            label: "Harisumiran DE - YouTube",
            url: "https://www.youtube.com/@harisumiranDE",
          },
        ],
      },
    ],
  },
  {
    country: "New Zealand",
    locations: [
      {
        city: "Auckland",
        map: {
          query:
            "133c Central Park Drive, Henderson, Auckland 0610, New Zealand",
        },
        links: [
          {
            label: "Hariprabodham NZ",
            url: "https://hariprabodham.org.nz/",
          },
          {
            label: "HariPrabodham Niramay NZ - YouTube",
            url: "https://www.youtube.com/@hariprabodhamnz",
          },
        ],
      },
    ],
  },
  {
    country: "Australia",
    locations: [
      {
        city: "Melbourne",
        map: {
          query:
            "1990 South Gippsland Hwy, Devon Meadows VIC 3977, Australia",
        },
        links: [
          {
            label: "Hari Prabodham Australia",
            url: "https://hariprabodham.org.au/",
          },
          {
            label: "Hari Prabodham Australia - YouTube",
            url: "https://www.youtube.com/@hariprabodhamaustralia",
          },
          {
            label: "Hari Prabodham Australia - Instagram",
            url: "https://www.instagram.com/hariprabodham_australia",
          },
        ],
      },
    ],
  },
];

const INDIA_CENTERS = ALL_CENTERS.filter(
  (center) => center.country === "India",
);
const INTERNATIONAL_CENTERS = ALL_CENTERS.filter(
  (center) => center.country !== "India",
);

function CenterCards({ centers, cityAsPanel = false }) {
  const renderLocationContent = (location) => (
    <>
      {location.links.length > 0 ? (
        <ul>
          {location.links.map((link) => (
            <li key={`${location.city}-${link.url}`}>
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <p className="coming-soon">Details coming soon.</p>
      )}
    </>
  );

  if (cityAsPanel) {
    return (
      <div className="centers-grid">
        {centers.flatMap((center) =>
          center.locations.map((location) => (
            <article
              className="center-country-card"
              key={`${center.country}-${location.city}`}
            >
              <h2>
                {location.city}
                {location.map && (
                  <a
                    href={`https://www.google.com/maps?q=${encodeURIComponent(location.map.query || `${location.map.lat},${location.map.lng}`)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="map-pin-link"
                    title={`Open ${location.city} on Google Maps`}
                    aria-label={`Open ${location.city} on Google Maps`}
                  >
                    <svg
                      className="map-pin-icon"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        fill="currentColor"
                        d="M12 2c-4.08 0-7.4 3.32-7.4 7.4 0 5.51 7.4 12.6 7.4 12.6s7.4-7.09 7.4-12.6C19.4 5.32 16.08 2 12 2zm0 10.3a2.9 2.9 0 1 1 0-5.8 2.9 2.9 0 0 1 0 5.8z"
                      />
                    </svg>
                  </a>
                )}
              </h2>
              {renderLocationContent(location)}
            </article>
          )),
        )}
      </div>
    );
  }

  return (
    <div className="centers-grid">
      {centers.map((center) => (
        <article className="center-country-card" key={center.country}>
          <h2>{center.country}</h2>
          <div className="center-locations">
            {center.locations.map((location) => (
              <div
                className="center-location-card"
                key={`${center.country}-${location.city}`}
              >
                <h3>
                  {location.city}
                  {location.map && (
                    <a
                      href={`https://www.google.com/maps?q=${encodeURIComponent(location.map.query || `${location.map.lat},${location.map.lng}`)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="map-pin-link"
                      title={`Open ${location.city} on Google Maps`}
                      aria-label={`Open ${location.city} on Google Maps`}
                    >
                      <svg
                        className="map-pin-icon"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                      >
                        <path
                          fill="currentColor"
                          d="M12 2c-4.08 0-7.4 3.32-7.4 7.4 0 5.51 7.4 12.6 7.4 12.6s7.4-7.09 7.4-12.6C19.4 5.32 16.08 2 12 2zm0 10.3a2.9 2.9 0 1 1 0-5.8 2.9 2.9 0 0 1 0 5.8z"
                        />
                      </svg>
                    </a>
                  )}
                </h3>
                {renderLocationContent(location)}
              </div>
            ))}
          </div>
        </article>
      ))}
    </div>
  );
}

export function CentersView({ title, subtitle, centers, cityAsPanel = false }) {
  return (
    <main className="page-content centers-page">
      <section className="page-header">
        <h1 className="section-title">{title}</h1>
        <p className="header-subtitle">{subtitle}</p>
      </section>

      <section className="page-body">
        <CenterCards centers={centers} cityAsPanel={cityAsPanel} />
      </section>
    </main>
  );
}

function Centers() {
  return (
    <main className="page-content centers-page">
      <section className="page-header">
        <h1 className="section-title">Hariprabodham Centers</h1>
        <p className="header-subtitle">India and International Centers</p>
      </section>

      <section className="page-body">
        <h2>India Centers</h2>
        <CenterCards centers={INDIA_CENTERS} cityAsPanel />

        <h2>International Centers</h2>
        <CenterCards centers={INTERNATIONAL_CENTERS} />
      </section>
    </main>
  );
}

export default Centers;
